module.exports = new __parcel__URL__("battleroyale_view_results_button.469f52ad.png").toString();